import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-gray-900 text-gray-400 py-12 border-t border-gray-800" data-id="element-116">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-117">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-118">
          <div className="col-span-1 md:col-span-2" data-id="element-119">
            <h3 className="font-serif text-2xl font-bold text-white mb-2" data-id="element-120">
              Juliet González
            </h3>
            <p className="text-gray-500 uppercase tracking-wider text-sm font-medium mb-4" data-id="element-121">
              Psicóloga Clínica
            </p>
            <p className="max-w-xs text-gray-400" data-id="element-122">
              Acompañamiento profesional y humano para niños y adultos en Berks
              County.
            </p>
          </div>

          <div data-id="element-123">
            <h4 className="font-bold text-white mb-4" data-id="element-124">Enlaces rápidos</h4>
            <ul className="space-y-2" data-id="element-125">
              <li data-id="element-126">
                <a href="#about" className="hover:text-white transition-colors" data-id="element-127">
                  Sobre mí
                </a>
              </li>
              <li data-id="element-128">
                <a href="#services" className="hover:text-white transition-colors" data-id="element-129">
                  Servicios
                </a>
              </li>
              <li data-id="element-130">
                <a href="#approach" className="hover:text-white transition-colors" data-id="element-131">
                  Enfoque clínico
                </a>
              </li>
              <li data-id="element-132">
                <a href="#process" className="hover:text-white transition-colors" data-id="element-133">
                  Proceso
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-134">
            <h4 className="font-bold text-white mb-4" data-id="element-135">Contacto</h4>
            <ul className="space-y-2" data-id="element-136">
              <li data-id="element-137">Reading Behavioral Health</li>
              <li data-id="element-138">Reading, Berks County, PA</li>
              <li data-id="element-139">
                <a href="tel:6103747035" className="hover:text-white transition-colors" data-id="element-140">
                  610-374-7035
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm" data-id="element-141">
          <div className="mb-4 md:mb-0" data-id="element-142">
            &copy; {currentYear} Juliet González. Todos los derechos reservados.
          </div>
          <div data-id="element-143">
            <span className="text-gray-500" data-id="element-144">Aviso de privacidad</span>
          </div>
        </div>

        <div className="mt-8 p-4 bg-gray-800 rounded-lg text-xs text-gray-500 text-center max-w-4xl mx-auto" data-id="element-145">
          <p data-id="element-146">
            <strong data-id="element-147">IMPORTANTE:</strong> Esta información es de carácter
            orientativo y no sustituye atención de emergencia. En caso de crisis
            o emergencia, llama al 911 o acude a la sala de emergencias más
            cercana.
          </p>
        </div>
      </div>
    </footer>;
}